import { IconMainMenuCLI } from "@suse-o11y/icons";
import React, { type FC } from "react";

import { Permission } from "~/models/dto";

import { usePermissions } from "../../common/use-permissions";
import { useNavigateToLink } from "../../components/react/link";
import { CLIPROFILE_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemCLIProfile: FC = () => {
	const permissions = usePermissions();
	const link = useNavigateToLink(CLIPROFILE_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	if (!permissions?.hasSystemPermission(Permission.GetApiTokens)) {
		return null;
	}

	return (
		<MainMenuItemLayout
			className="cliProfileMenu"
			icon={<IconMainMenuCLI height={18} width={18} />}
			label="CLI"
			to={link}
		/>
	);
};
